import React, { useEffect, useState } from "react";
import { apiFetchVeyaTeam } from "../../lib/api";

export default function VeyaTeamActivity() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadActivity() {
    setLoading(true);
    setError("");

    try {
      const data = await apiFetchVeyaTeam("/interaction-events/recent");
      setEvents(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load activity", err);
      setError(err?.message || "Could not load activity.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadActivity();
  }, []);

  function formatTime(ts) {
    if (!ts) return "";
    return new Date(ts).toLocaleString();
  }

  const eventCounts = events.reduce((acc, e) => {
  acc[e.event_type] = (acc[e.event_type] || 0) + 1;
  return acc;
}, {});

  return (
    <div style={{ display: "grid", gap: 18 }}>
      {/* HEADER */}
      <div className="merchant-card">
        <h2 style={{ marginTop: 0 }}>Activity / Debug</h2>
        <p style={{ opacity: 0.72 }}>
          Live system activity and interaction diagnostics.
        </p>
      </div>

      {/* LIVE EVENTS */}
      <div className="merchant-card">
        <h3 style={{ marginTop: 0 }}>Recent activity</h3>

        {loading ? <p>Loading activity...</p> : null}
        {error ? <p className="merchant-error">{error}</p> : null}

        {!loading && events.length === 0 ? (
          <p style={{ opacity: 0.7 }}>No activity yet.</p>
        ) : null}

        <div style={{ display: "grid", gap: 10 }}>
          {events.map((e) => (
            <div
              key={e.id}
              style={{
                padding: 12,
                borderRadius: 14,
                border: "1px solid rgba(176,140,108,0.22)",
                background: "rgba(251,247,242,0.55)",
                display: "grid",
                gap: 4,
              }}
            >
              <div style={{ fontWeight: 700 }}>
                {e.event_type}
              </div>

              <div style={{ fontSize: 13, opacity: 0.75 }}>
                Product: {e.product_id || "—"} · Edit: {e.edit_id || "—"}
              </div>

              <div style={{ fontSize: 12, opacity: 0.6 }}>
                {formatTime(e.created_at)}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="merchant-card">
  <h3 style={{ marginTop: 0 }}>Event breakdown</h3>

  {Object.keys(eventCounts).length === 0 ? (
    <p style={{ opacity: 0.7 }}>No events yet.</p>
  ) : (
    <div style={{ display: "grid", gap: 6 }}>
      {Object.entries(eventCounts).map(([type, count]) => (
        <div
          key={type}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 10px",
            borderRadius: 10,
            background: "rgba(251,247,242,0.55)",
            border: "1px solid rgba(176,140,108,0.22)",
            fontSize: 14,
          }}
        >
          <span style={{ fontWeight: 600 }}>{type}</span>
          <span style={{ opacity: 0.75 }}>{count}</span>
        </div>
      ))}
    </div>
  )}
</div>

      {/* SIGNAL SUMMARY */}
      <div className="merchant-card">
        <h3 style={{ marginTop: 0 }}>Signal snapshot</h3>

        <p style={{ fontSize: 14, opacity: 0.7 }}>
          This will evolve into demand insights (top styles, colours, silhouettes).
        </p>

        <div
          style={{
            padding: 12,
            borderRadius: 14,
            border: "1px dashed rgba(176,140,108,0.3)",
            background: "rgba(251,247,242,0.45)",
            fontSize: 13,
            opacity: 0.65,
          }}
        >
          Coming next: aggregated signals from shopper edits + interactions.
        </div>
      </div>

      {/* SYSTEM HEALTH */}
      <div className="merchant-card">
        <h3 style={{ marginTop: 0 }}>System health</h3>

        <div style={{ display: "grid", gap: 8, fontSize: 14 }}>
          <div>• Interaction events: logging</div>
          <div>• Edit signals: generating</div>
          <div>• Merchant catalogs: connected</div>
        </div>
      </div>
    </div>
  );
}